import { type LoadableResponse } from "api-types";
import { getDocs, limit, query, where } from "firebase/firestore/lite";
import { useFirebase, useThrowAsyncError } from "igfd-commons";

import { useEffect, useState } from "react";

type IgfdMenuUrlDoc = {
  city: string;
  urlSlug: string;
};

const igfdMenuUrlFromDoc = (doc: IgfdMenuUrlDoc): string => {
  return `https://igfd.menu/${doc.city}/${doc.urlSlug}`;
};

export const useIgdfMenuUrl = (
  // This is a hack to delay loading until the restaurantUuid is available.
  // We should refactor this hook into the redux store.
  restaurantUuid?: string,
  locationId: string | null = null
): LoadableResponse<string> => {
  const firebase = useFirebase();

  const [igfdMenuUrl, setIgfdMenuUrl] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const throwAsyncError = useThrowAsyncError();

  useEffect(() => {
    setIsLoading(true);
    if (!restaurantUuid) {
      // this is when the a user logs out and logs in with 0 restaurants, we should reset the state.
      setIgfdMenuUrl(undefined);
      setIsLoading(false);
      return;
    }

    getDocs(
      query(
        firebase.firestoreRefs.igfdMenuUrls(),
        where("restaurantUuid", "==", restaurantUuid),
        where("locationId", "==", locationId),
        limit(1)
      )
    )
      .then((snapshot) => {
        if (snapshot.empty) {
          setIgfdMenuUrl(undefined);
        } else {
          const doc = snapshot.docs[0];
          const igfdMenuUrl = igfdMenuUrlFromDoc(doc.data() as IgfdMenuUrlDoc);
          setIgfdMenuUrl(igfdMenuUrl);
        }
      })
      .catch(throwAsyncError)
      .finally(() => {
        setIsLoading(false);
      });
  }, [restaurantUuid, locationId]);

  return {
    isLoading,
    data: igfdMenuUrl,
  } as LoadableResponse<string>;
};
